module.exports = __webpack_public_path__ + "img/product3.b8d03be2.png";